import { apiClient } from '../../gateways/api'
import type { Projectdossier } from '../../projectdossier/types/Projectdossier'

export { createProjectdossier }

const createProjectdossier = async ({
  projectdossier,
}: {
  projectdossier: Partial<Projectdossier>
}): Promise<Projectdossier> => {
  const { data } = await apiClient({
    url: '/rest/projectdossier',
    method: 'POST',
    data: projectdossier,
  })

  return data
}
